export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 19 September 2023.ee47630e.pdf";